function startTimer(cooldown, timerDone){
  timerDone.value = false;
  setTimeout(() => {
    timerDone.value = true;
  }, cooldown);
  return timerDone.value
}

let timerDone = { value: true };

export {startTimer, timerDone};